<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Opera
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>Opera experienced a decline in revenue by 14.4% (from $47.0m in 2018 to $40.2m in 2019) and a decline in attendance by 10.6% (from 0.5m in 2018 to 0.4m in 2019). The average ticket price declined by 8.3% (from $124.11 in 2018 to $113.83 in 2019). Major opera performances in 2019 included those from Opera Australia’s Sydney Summer Season, Opera Australia’s Sydney Winter Season and Great Opera Hits.</p>
          <p>In 2020, the category experienced a decline in revenue (by 71.9% to $11.3m from 2019) and a decline in attendance (by 66.0% to 0.1m), due to COVID-19 restrictions and limited touring activity of AMPAG / NPAP companies.</p>
          <p>Additionally, a decline in the average ticket price by 23.2% (to $87.47) further contributed to the decline in revenue. Major opera performances in 2020 included <em>Carmen</em>, <em>La Boheme</em> and <em>Don Giovanni</em>. </p>
          <p>Similar to previous years, most of the revenue (96.1% in 2019, 95.4% in 2020) and attendance (93.2% in 2019, 92.2% in 2020) in the Opera category was generated through performances by AMPAG / NPAP companies including Opera Australia, Opera Queensland, West Australian Opera, Victorian Opera and the State Opera of South Australia.</p>
        </div>
        <div class="sixcol last">
          <p>In 2019, NSW and Victoria generated the majority of Opera revenue and attendance, with a combined 87.7% of revenue market share (68.1% and 19.6% respectively) and 71.4% of attendance market share.</p>
          <p>In 2020, NSW and WA generated the majority of Opera revenue with a combined 93.5% of revenue market share (89.7% and 3.8% respectively), while NSW and SA generated the majority of Opera attendance with combined 75.5% of market share (53.6% and 21.9% respectively).</p>
          <p>In 2019, NSW recorded a decline in revenue by 17.7% and a decline in attendance by 34.2% from 2018. In 2020, NSW recorded a decline in revenue by 62.9% and a decline in attendance by 62.3% from 2019.</p>
          <p>In 2019, SA witnessed the highest y-o-y growth in revenue (37.3%) and WA witnessed the highest y-o-y growth in attendance (146.1%). In 2020, all states experienced a decline in revenue, while all states except SA and ACT experienced a decline in attendance in the Opera category.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <ul class="switches">
          <li><a href="javascript:;" :class="{active: activeYear==2019}"
            @click="activeYear=2019">2019</a></li>
          <li><a href="javascript:;" :class="{active: activeYear==2020}"
            @click="activeYear=2020">2020</a></li>
        </ul>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>The Selfish Giant</em>, Victorian Opera, Photo Credit: Charlie Kinross</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
          backgroundColor: '#fff'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [62.562, 46.391, 48.331, 47.249, 41.317, 44.044, 40.129, 47.306, 47.844, 43.284, 42.621, 41.505, 46.248, 36.349, 46.965, 40.202, 11.314],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.63, 0.532, 0.516, 0.592, 0.403, 0.448, 0.41, 0.439, 0.431, 0.345, 0.387, 0.433, 0.408, 0.369, 0.487, 0.436, 0.148],
          color: '#d14967'
        }]
      },
      activeYear: 2019,
      stateBreakdowns: [
        {
          year: 2019,
          revenue: [
            ["NSW", 68.1],
            ["VIC", 19.6],
            ["QLD", 4.2],
            ["WA", 3.3],
            ["SA", 3.9],
            ["ACT", 0.1],
            ["TAS", 0.5],
            ["NT", 0.4]
          ],
          attendance: [
            ["NSW", 48.2],
            ["VIC", 23.2],
            ["QLD", 8.8],
            ["WA", 13.1],
            ["SA", 5.2],
            ["ACT", 0.1],
            ["TAS", 0.8],
            ["NT", 0.6]
          ]
        },
        {
          year: 2020,
          revenue: [
            ["NSW", 89.7],
            ["VIC", 3.7],
            ["QLD", 2.2],
            ["WA", 3.8],
            ["SA", 0.3],
            ["ACT", 0.3],
            ["TAS", 0.0],
            ["NT", 0.0]
          ],
          attendance: [
            ["NSW", 53.6],
            ["VIC", 4.8],
            ["QLD", 5.6],
            ["WA", 13.9],
            ["SA", 21.9],
            ["ACT", 0.3],
            ["TAS", 0.0],
            ["NT", 0.0]
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Revenue Share',
              data: stateBreakdown.revenue,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: true,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              }
            }, {
              name: 'Attendance Share',
              data: stateBreakdown.attendance,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -32
              }
            }],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("../../../assets/img/2019/The-Selfish-Giant,-Victorian-Opera,-Charlie-Kinross_SFW.jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
